import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WolfiePage from "../pages/wolfie/page";
import RubyPage from "../pages/ruby/page";
import LoginPage from "../pages/login/page";
import AccountPage from "../pages/account/page";
import ReviewsPage from "../pages/reviews/page";
import GalleryPage from "../pages/gallery/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/wolfie",
    element: <WolfiePage />,
  },
  {
    path: "/ruby",
    element: <RubyPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/account",
    element: <AccountPage />,
  },
  {
    path: "/reviews",
    element: <ReviewsPage />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
